/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
import type { ExchangeSaml2TokenRequest } from '../models/ExchangeSaml2TokenRequest';
import type { SuccessLoginResponse } from '../models/SuccessLoginResponse';

import type { CancelablePromise } from '../core/CancelablePromise';
import { OpenAPI } from '../core/OpenAPI';
import { request as __request } from '../core/request';

export class Saml2AuthControllerService {

    /**
     * Exchanges temporary saml token with a refresh and access tokens
     * @param requestBody
     * @returns SuccessLoginResponse OK
     * @throws ApiError
     */
    public static exchange(
        requestBody: ExchangeSaml2TokenRequest,
    ): CancelablePromise<SuccessLoginResponse> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/v1/auth/saml2/exchange',
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                400: `Bad Request`,
                401: `The client is not authorized to perform the action. The \`code\`, \`message\`, and \`data\` fields may provide more information about the reason of the error.`,
                404: `The requested entity was not found, or the client has no permission to access the entity.`,
                500: `An unexpected error has occurred.`,
            },
        });
    }

}
